import { createGradientOrSolid } from 'utils';
import styled from 'styled-components';
import { EGradientDirection } from 'utils/enums';

export const StyledSpecialOffer = styled.div`
  max-width: 400px;
  width: 100%;
  padding: 3px;
  min-height: 269px;
  aspect-ratio: 3/2.25;
  background: ${(props: any) => createGradientOrSolid(props.borderColor)};
  border-radius: 12px;
  font-family: var(--font-family), Arial;
  z-index: 1;
  position: relative;
  box-sizing: border-box;

  .backgroundImage {
    width: 100%;
    height: 100%;
    padding: ${(props: any) => props.boxPadding};
    border-radius: 10px;
    background: ${(props: any) =>
      props.backgroundImage
        ? `url("${props.backgroundImage}")`
        : createGradientOrSolid(props.backgroundColor)};
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
  }

  h2 {
    background: ${(props: any) => createGradientOrSolid(props.textColor)};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin: 0;
    font-size: ${(props: any) => `${props.fontSize}px`};
    font-weight: ${(props: any) => props.fontWeight};
    position: relative;

    &.match {
      background: linear-gradient(
        to bottom,
        rgb(255, 247, 199),
        rgb(226, 182, 109)
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    &:after {
      background: none;
      content: '${(props: any) => props.title}';
      left: 0;
      top: 0;
      z-index: -1;
      position: absolute;
      text-shadow: 0 2px 0px #000000;
    }
  }

  .productsContainer {
    width: 100%;
    max-height: 55%;
    padding: 10px;
    border-radius: 15px;
    background-color: rgba(0, 0, 0, 0.5);
    overflow-y: auto;
    overflow-x: hidden;
    z-index: 1;
    scroll-padding: 0 5px;
    display: flex;
    flex-direction: column;
    justify-content: start;

    // firefox
    scrollbar-width: thin;
    scrollbar-color: rgba(90, 90, 90) transparent;

    &::-webkit-scrollbar {
      width: 16px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(90, 90, 90);
      border: 6px solid transparent;
      border-radius: 12px;
      background-clip: padding-box;
    }

    .products {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;

      .product {
        display: flex;
        justify-content: space-between;
        margin-right: 8px;
        align-items: start;

        &:last-child {
          margin-right: 0;
        }

        & .stroked {
          margin: 0;
          font-size: 14px;
          font-weight: 600;
          max-width: max-content;
          position: relative;
          background: ${() =>
            createGradientOrSolid({
              colorOne: '#E2E8ED',
              colorTwo: '#C9AFB3',
              gradientDirection: EGradientDirection.TopToBottom,
            })};
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;

          &::after {
            content: ' ';
            height: 2px;
            width: 100%;
            background: #d8232a;
            position: absolute;
            left: 0;
            top: 50%;
          }
        }

        &__match {
          margin: 0 0.5em;
        }
      }

      &.mainProducts {
        .image-container {
          height: 32px;
          width: 32px;
          margin-right: 2px;

          &--image {
            height: 100%;
            width: 100%;
            object-fit: contain;
          }

          &--match {
            height: 62px;
            width: 62px;
            margin-right: 2px;
          }

          @media (max-width: 450px) {
            &--match {
              max-height: 48px;
              max-width: 48px;
            }
          }
        }

        h4 {
          font-size: 18px;
          font-weight: 700;
          margin: 0;
        }
      }

      &.secondaryProduct {
        margin-top: 8px;

        .product {
          flex-direction: row;
          align-items: center;
        }

        .content-container p {
          padding: 0;
        }

        .product-image-container {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        img {
          max-height: 28px;
        }

        h4 {
          color: white;
          font-size: 14px;
          font-weight: 500;
          margin: 0 0 0 2px;
        }
      }
    }

    .mainProducts h4 {
      background: linear-gradient(
        to bottom,
        rgb(255, 247, 199),
        rgb(226, 182, 109)
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      position: relative;

      &:after {
        background: none;
        content: attr(data-text);
        left: 0;
        top: 0;
        z-index: -1;
        position: absolute;
        text-shadow: 0 2px 0px #000000;
      }
    }

    .mainProducts.match h4 {
      background: #fff;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      position: relative;
      font-size: 16px;

      &:after {
        background: none;
        content: attr(data-text);
        left: 0;
        top: 0;
        z-index: -1;
        position: absolute;
        text-shadow: 0 2px 0px #000000;
      }
    }

    .divider {
      width: 85%;
      height: 1%;
      background-color: white;
    }
  }

  span {
    color: white;
    text-shadow: 0 2px 0 black;

    &.availability {
      z-index: 10;
      font-size: 12px;
      font-weight: 700;
      position: absolute;
      bottom: 7px;
      margin: 4px 0;

      &.countdown {
        right: 8px;
      }

      &.quantity {
        right: 12px;
      }
    }
  }
` as any;
